module.exports = __webpack_public_path__ + "img/personal-laser-defense-equipment.a92606b3.png";